import template from './template.html';
import './styles.css';

controller.$inject = ['$scope', 'DateService'];

export function controller($scope, DateService) {
    let currentPeriod;
    let vm = {};
    this.$onInit = function() {
    vm = this;

    vm.previous = previous;
    vm.next = next;
    vm.changeWeek = changeWeek;
    vm.isValidWeek = isValidWeek;

    setPeriod(vm.date);
    }
    function setPeriod(date){
        vm.date = DateService.getSundayForDate(date);
        vm.endDate = addDays(vm.date, 6);

        let jsdate = DateService.convertToJSPLCDate(vm.date);
        currentPeriod = jsdate.period;
        let daysOffset = (currentPeriod - 1) * 28;
        
        daysOffset = daysOffset + ((jsdate.week - 1) * 7);

        let startDate = addDays(vm.date, -daysOffset);
        let startYear = DateService.convertToJSPLCDate(startDate);

        let financialYear = startYear.year;
        
        vm.week1Selected = jsdate.week === 1;
        vm.week2Selected = jsdate.week === 2;
        vm.week3Selected = jsdate.week === 3;
        vm.week4Selected = jsdate.week === 4;

        vm.selectedYear = financialYear;
        vm.selectedPeriod = 'Period ' + currentPeriod;
        vm.previousYearEnabled = true;
        vm.nextYearEnabled = true;

        vm.period = vm.selectedYear + ' ' + vm.selectedPeriod + ' Week ' + 
            (vm.week1Selected ? 1 : vm.week2Selected ? 2 : vm.week3Selected ? 3 : 4);
    }

    function getFormattedDate(dt) {
        var day = dt.getDate();
        var month = dt.getMonth();
        var year = dt.getFullYear();
        var months = ['January','Febuary','March','April','May','June','July','August','September','October','November','December'];

        return (day<10?"0"+day:day) + " " + months[month] + " " + year;
    }

    function isValidWeek(week){
        return true;
    }

    function previous(type){
    	if(type === 'year'){
            vm.date = DateService.getSundayForDate(addDays(vm.date, -364));
            vm.endDate = addDays(vm.date, 6);
            setPeriod(vm.date);
    	}
    	else if(type === "period"){
            if(currentPeriod === 1) return;
            
            currentPeriod--;

            vm.selectedPeriod = "Period " + currentPeriod;
            vm.date = DateService.getSundayForDate(addDays(vm.date, -28));
            vm.endDate = addDays(vm.date, 6);
            setPeriod(vm.date);
    	}
    }

    function next(type){
    	if(type === 'year'){
            vm.date = DateService.getSundayForDate(addDays(vm.date, 364));
            vm.endDate = addDays(vm.date, 6);
            setPeriod(vm.date);
    	}
    	else if(type === "period"){
            if(currentPeriod === 13 ) return;
            currentPeriod++;

            vm.selectedPeriod = "Period " + currentPeriod;
            vm.date = DateService.getSundayForDate(addDays(vm.date, 28));
            vm.endDate = addDays(vm.date, 6);
            setPeriod(vm.date);
    	}
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setHours(12);
        result.setDate(result.getDate() + days);
        return result;
    }

    function changeWeek(weekno){
        let prevWeek = vm.week1Selected ? 1 : vm.week2Selected ? 2 : vm.week3Selected ? 3 : 4;

		vm.week1Selected = false;
    	vm.week2Selected = false;
		vm.week3Selected = false;
		vm.week4Selected = false;

    	switch(weekno){
    		case 1:
    			vm.week1Selected = true;
    			break;
    		case 2:
    			vm.week2Selected = true;
    			break;
    		case 3:
    			vm.week3Selected = true;
    			break;
    		default:
	    		vm.week4Selected = true;
	    		break;
    	}
        
        let currentWeekNo = vm.week1Selected ? 1 : vm.week2Selected ? 2 : vm.week3Selected ? 3 : 4;
        vm.date = DateService.getSundayForDate(addDays(vm.date, 7 * (currentWeekNo > prevWeek ? Math.abs(currentWeekNo - prevWeek) : -Math.abs(currentWeekNo - prevWeek))));
        vm.endDate = addDays(vm.date, 6);
        setPeriod(vm.date);
        vm.show = false;
    }
}

export default () => ({
    template: template,
    controller: controller,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: {
        minPeriodYear: '=',
        maxPeriodYear: '=',
        date: '='
    },
    scope: {},
});



// WEBPACK FOOTER //
// ./src/js/components/common/periodpicker/index.js